import React from "react";
import { connect } from "react-redux";
import { Row, Col, Label, InputGroup, FormGroup, Input } from "reactstrap";
import { pageActions } from "../../../../../store/actions/cms/page/page.action";
import { formActions } from "../../../../../store/actions/cms/form/form.action";
import { sourceTypes } from "../../../../../constants/cms/sourceType";
import { deepClone } from "../../../../../helpers/objectHelper";
import SystemLabel from "../../../../../system/SystemLabel/SystemLabel";
import ListExpansion from "../../../../../components/UI/ListExpansion/ListExpansion";
import { templateHelper } from "../../../../areas/template/helpers/templateHelper";
import { templateActions } from "../../../../../store/actions/cms/template/template.action";
import { UrlMultiInput } from "../../../../components/editor/tools/UrlMultiInput/UrlMultiInput";
import EditorSlider from "../../../../components/editor/tools/EditorSlider";
import { AlignmentButtonGroup } from "../../../../components/editor/tools/AlignmentButtonGroup/AlignmentButtonGroup";
import Select from "react-select";
import Axios from "axios";

class CalendarInvitationSettings extends React.Component {
  state = {
    isMediaVaultOpen: false,
    invitations: [],
  };
  handleSoftUpdate = (element) => {
    const { dispatch, enviroment, page } = this.props;
    if (enviroment === sourceTypes.FORM) dispatch(formActions.updateFormElement(element));
    if (enviroment === sourceTypes.PAGE) dispatch(pageActions.updatePageElement(element, null, page));
    if (enviroment === sourceTypes.TEMPLATE) {
      const template = deepClone(this.props.template);
      const newTemplate = templateHelper.handleElementUpdates(element, template);
      dispatch(templateActions.softUpdate(newTemplate));
    }
  };
  componentDidMount() {
    this.fetchCalendarInvitations();
  }

  fetchCalendarInvitations = () => {
    Axios.get(`./api/calendar/getCalendarInvites/${this.props.cms.eventId}`).then(({ data }) => {
      this.setState({
        invitations: data.map((d) => {
          return {
            value: d.calendarInviteId,
            label: d.name,
          };
        }),
      });
    });
  };
  toggle = (tabPane, tab) => {
    const newArray = this.state.activeTab.slice();
    newArray[tabPane] = tab;
    this.setState({
      activeTab: newArray,
    });
  };
  handleChange = (e, val, path) => {
    const names = path.split(".");
    const element = deepClone(this.props.selectedElement);
    let value = null;
    if (val && val.hex !== undefined) {
      const { r, g, b, a } = val.rgb;
      value = `rgba(${r},${g},${b},${a})`;
    } else if (val) value = val;
    else if (e !== null) value = e.target.value;
    else return;
    if (names.length === 2) {
      element[names[0]][names[1]] = value;
    } else if (names.length === 3) {
      element[names[0]][names[1]][names[2]] = value;
    } else if (names.length === 4) {
      element[names[0]][names[1]][names[2]][names[3]] = value;
    }
    this.handleSoftUpdate(element);
  };

  toggleMediaVault = () => {
    this.setState({ isMediaVaultOpen: !this.state.isMediaVaultOpen });
  };
  render() {
    const selectStyles = {
      option: (styles, { data }) => {
        return {
          ...styles,
          fontSize: "12px",
          fontFamily: data.value,
          padding: "0 10px",
        };
      },
      container: (styles) => ({
        ...styles,
        minWidth: "100%",
        borderRight: "1px solid gainsboro",
      }),
      /*       control: styles => ({
                        borderWidth: '1px'
                    }), */
      singleValue: (styles, { data }) => {
        return {
          ...styles,
          fontSize: "12px",
          fontFamily: data.value,
        };
      },
    };
    const { selectedElement } = this.props;
    return (
      <div>
        <ListExpansion footer={false} icon="fa fa-image" description="InvitationsSettings" defaultExpanded={true}>
          <Row>
            <Col className="list-setting-item-title">
              <Label>
                <SystemLabel name="SelectInvitation" />
              </Label>
            </Col>
          </Row>
          <Row>
            <Col className="list-setting-item-title" style={{ lineHeight: "unset" }}>
              <InputGroup style={{ display: "inline-flex", flexWrap: "nowrap", alignItems: "unset", maxWidth: "100%" }}>
                <Select
                  className="jirango-fontpicker no-prepend"
                  classNamePrefix="jirango-fontpicker"
                  options={this.state.invitations}
                  value={
                    selectedElement
                      ? {
                          value: selectedElement.data.invitationId,
                          label: this.state.invitations.find((i) => i.value == selectedElement.data.invitationId)?.label,
                        }
                      : null
                  }
                  onChange={(selectedOption) => this.handleChange(null, selectedOption.value, "data.invitationId")}
                  styles={selectStyles}
                />
              </InputGroup>
            </Col>
          </Row>
          <br />
          <AlignmentButtonGroup onChange={this.handleChange} alignment={selectedElement.data.alignment} path="data.alignment" type={["left", "center", "right"]} />
          <br />
          <Row>
            <Col className="list-setting-item-title">
              <FormGroup style={{ width: "100%" }}>
                <Label htmlFor="text-label">
                  <SystemLabel name={`DisplayText`} />
                </Label>
                <Input
                  id="text-label"
                  autoComplete="jirango-nofill"
                  value={selectedElement.props.value ? selectedElement.props.value : ""}
                  onChange={(e) => this.handleChange(e, null, `props.value`)}
                />
              </FormGroup>
            </Col>
          </Row>
        </ListExpansion>
      </div>
    );
  }
}
function mapStateToProps(state) {
  const { enviroment } = state.cms;
  let selectedElement = null;
  if (enviroment === sourceTypes.FORM) selectedElement = state.form.selectedElement;
  if (enviroment === sourceTypes.PAGE) selectedElement = state.page.selectedElement;
  if (enviroment === sourceTypes.TEMPLATE) selectedElement = state.template.selectedElement;
  return {
    enviroment: enviroment,
    template: state.template.template,
    form: state.form,
    page: state.page,
    selectedElement: selectedElement,
    cms: state.cms,
  };
}
export default connect(mapStateToProps)(CalendarInvitationSettings);
